import { REPORTS_SECTIONS_ROUTES } from '@/models/app-internal/permissions.model';

export enum ENV_VAR_NAMES {
  APP_MODE = 'APP_MODE',
  MOCKS_ENABLED = 'MOCKS_ENABLED',
  BACKOFFICE_API_URL = 'BACKOFFICE_API_URL',
  MULTIBRAND_API_URL = 'MULTIBRAND_API_URL',
  WL_SLUG = 'WL_SLUG',
  SERVICE_PERMISSIONS = 'SERVICE_PERMISSIONS',
  CURRENT_PARTENT_ROUTE_NAME = 'CURRENT_PARTENT_ROUTE_NAME',
}

export enum REPORTS_MODES {
  STANDALONE = 'standalone',
  BACKOFFICE = 'backoffice',
}

export type EnvConfig = {
  [ENV_VAR_NAMES.APP_MODE]: REPORTS_MODES | string;
  [ENV_VAR_NAMES.MOCKS_ENABLED]: string;
  [ENV_VAR_NAMES.BACKOFFICE_API_URL]: string;
  [ENV_VAR_NAMES.MULTIBRAND_API_URL]: string;
  [ENV_VAR_NAMES.WL_SLUG]: string;
  [ENV_VAR_NAMES.CURRENT_PARTENT_ROUTE_NAME]: PARENT_ROUTE_NAMES;
};

export type EnvVariables = Record<string, string | undefined>;

export const DEFAULT_PROPS = (): DefaultProps => {
  return {
    apiUrl: 'https://dev.aramuz.net/backofficeapi',
    multibrandApiUrl: '',
    wlSlug: localStorage.getItem('defaultWlSlug') || '',
    currentParentRouteName: '',
    reportsPermissions: '',
  };
};

export type Props = {
  apiUrl: string;
  multibrandApiUrl: string;
  wlSlug: string;
  currentParentRouteName: PARENT_ROUTE_NAMES;
  reportsPermissions: string;
}

export type DefaultProps = {
  apiUrl: Props['apiUrl'];
  multibrandApiUrl: Props['multibrandApiUrl'];
  wlSlug: Props['wlSlug'];
  currentParentRouteName: Props['currentParentRouteName'];
  reportsPermissions: Props['reportsPermissions'];
}

export type PARENT_ROUTE_NAMES = '' | REPORTS_SECTIONS_ROUTES;
/* Указываем все дочерние роуты этого микрофронта
для каждого из них создаем enum — один подраздел, один enum
export type PARENT_ROUTE_NAMES = '' | OTHER_ROUTE_NAMES | SOME_OTHER_ROUTE_NAMES;
*/
